<template>
	<form class="form" @submit.prevent="sendToPreview" novalidate>
		<fieldset class="form__group">
			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

			<legend>The Impact</legend>

			<div class="form__group">
				<textarea id="value-added" class="form__control" v-model="formData.differenceMade" v-validate
				          placeholder="Enter a paragraph here..."></textarea>
				<label for="value-added" class="form__label">(Optional) The value the User added to the project</label>
			</div>

			<div class="form__group">
				<textarea id="testimonial" class="form__control" v-model="formData.testimonial" v-validate
				          placeholder="Enter a paragraph here..."></textarea>
				<label for="testimonial" class="form__label">(Optional) Testimonial quote</label>
			</div>

			<div class="form__group">
				<input id="testimonial-source" class="form__control" v-model="formData.testimonialPerson" v-validate
				       placeholder="Enter the name of the testimonial person here..." />
				<label for="testimonial-source" class="form__label">(Optional) Testimonial source</label>
			</div>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Preview</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import MADDFormStep from './MADDFormStep';
	import ValidationAlert from '../../ValidationAlert';

	export default {
		name: 'MADDFormStep4',
		components: {ValidationAlert},
		mixins: [MADDFormStep],
		data() {
			return {
				formData: {
					differenceMade: '',
					testimonial: '',
					testimonialPerson: '',
				}
			}
		},
	}
</script>
